export const fixedDrawerStyles = (props = {}) => {
  const { sideNavWidth = "", appBarHeight = "" } = props;

  return {
    bottomPush: {
      height: "16px",
    },
    drawer: (theme) => {
      return {
        flexShrink: 0,
        width: sideNavWidth,
        "& .MuiPaper-root": {
          borderRight: "none",
          background: `linear-gradient(180deg, ${theme?.palette?.primary?.main || "#002843"} 0%, #032d42 50%, #021e2d 100%)`,
          boxShadow: "4px 0 30px rgba(0, 0, 0, 0.3)",
          overflowX: "hidden",
          overflowY: "auto",
          position: "relative",
          // Subtle pattern overlay
          "&::before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "radial-gradient(circle at 50% 0%, rgba(160, 196, 109, 0.08) 0%, transparent 50%)",
            pointerEvents: "none",
          },
          // Custom scrollbar
          "&::-webkit-scrollbar": {
            width: "4px",
          },
          "&::-webkit-scrollbar-track": {
            background: "transparent",
          },
          "&::-webkit-scrollbar-thumb": {
            background: "rgba(160, 196, 109, 0.4)",
            borderRadius: "4px",
            "&:hover": {
              background: "rgba(160, 196, 109, 0.6)",
            },
          },
        },
      };
    },
    listItem: {
      paddingLeft: "8px",
      paddingRight: "8px",
      paddingTop: "8px",
      paddingBottom: "8px",
      justifyContent: "center",
      position: "relative",
      cursor: "pointer",
      transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
      "& *": {
        color: "rgba(255, 255, 255, 0.7)",
        transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
      },
      // Animated left indicator bar
      "&::before": {
        content: '""',
        position: "absolute",
        left: 0,
        top: "50%",
        transform: "translateY(-50%)",
        width: "4px",
        height: "0%",
        background: "linear-gradient(180deg, #A0C46D 0%, #7a9c4a 100%)",
        borderRadius: "0 4px 4px 0",
        transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
        boxShadow: "0 0 0px rgba(160, 196, 109, 0)",
      },
      // Glow effect behind on hover
      "&::after": {
        content: '""',
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: "85%",
        height: "85%",
        borderRadius: "16px",
        background: "radial-gradient(ellipse, rgba(160, 196, 109, 0.12) 0%, transparent 70%)",
        opacity: 0,
        transition: "opacity 0.3s ease-in-out",
        pointerEvents: "none",
      },
      "&:focus-visible": {
        outline: "none",
        "& *": {
          color: "#ffffff !important",
        },
        "&::before": {
          height: "60%",
          boxShadow: "0 0 15px rgba(160, 196, 109, 0.6)",
        },
        "&::after": {
          opacity: 1,
        },
      },
      "&:hover": {
        "& *": {
          color: "#ffffff !important",
        },
        "&::before": {
          height: "50%",
          boxShadow: "0 0 10px rgba(160, 196, 109, 0.4)",
        },
        "&::after": {
          opacity: 1,
        },
        // Float up effect
        "& .nav-icon-box": {
          transform: "translateY(-2px) scale(1.05)",
          boxShadow: "0 8px 20px rgba(160, 196, 109, 0.25)",
          backgroundColor: "rgba(160, 196, 109, 0.2)",
        },
      },
      "&:active": {
        "& .nav-icon-box": {
          transform: "translateY(0) scale(0.98)",
        },
      },
    },
    listItemActive: {
      "& *": {
        color: "#ffffff !important",
      },
      "&::before": {
        height: "70% !important",
        boxShadow: "0 0 20px rgba(160, 196, 109, 0.7) !important",
      },
      "&::after": {
        opacity: "1 !important",
      },
      "& .nav-icon-box": {
        backgroundColor: "rgba(160, 196, 109, 0.25) !important",
        boxShadow: "0 4px 15px rgba(160, 196, 109, 0.3), inset 0 1px 0 rgba(255,255,255,0.1) !important",
        border: "1px solid rgba(160, 196, 109, 0.3) !important",
      },
    },
    // Icon wrapper box
    navIconBox: {
      width: "32px",
      height: "32px",
      borderRadius: "10px",
      backgroundColor: "rgba(255, 255, 255, 0.05)",
      border: "1px solid rgba(255, 255, 255, 0.08)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      marginBottom: "4px",
      transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    },
    listItemIcon: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "1rem",
      width: "1rem",
      height: "1rem",
      "& svg": {
        width: "100%",
        height: "100%",
      },
    },
    listItemText: {
      margin: 0,
      textAlign: "center",
      "& .MuiListItemText-primary": {
        fontSize: "0.65rem",
        textAlign: "center",
        fontWeight: 600,
        letterSpacing: "0.04em",
        textTransform: "uppercase",
        lineHeight: 1.2,
        whiteSpace: "nowrap",
        color: "rgba(255, 255, 255, 0.7) !important",
      },
    },
    menuIcon: {
      height: appBarHeight,
      justifyContent: "center",
      padding: "20px 12px",
      marginBottom: "8px",
      position: "relative",
      // Gradient divider line below logo
      "&::after": {
        content: '""',
        position: "absolute",
        bottom: 0,
        left: "10%",
        width: "80%",
        height: "1px",
        background: "linear-gradient(90deg, transparent, rgba(160, 196, 109, 0.5), transparent)",
      },
      "&:hover": {
        backgroundColor: "transparent",
        "& img": {
          transform: "scale(1.08)",
        },
      },
      "& img": {
        transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
      },
    },
    menuItem: (theme) => ({
      backgroundColor: "transparent",
      color: "rgba(255, 255, 255, 0.9)",
      padding: "14px 20px",
      fontSize: "0.875rem",
      fontWeight: 500,
      transition: "all 0.25s cubic-bezier(0.4, 0, 0.2, 1)",
      position: "relative",
      borderLeft: "3px solid transparent",
      "&:hover": {
        color: "#ffffff",
        backgroundColor: "rgba(160, 196, 109, 0.15)",
        borderLeftColor: "#A0C46D",
        paddingLeft: "24px",
      },
    }),
    menuList: {
      justifyContent: "center",
      paddingBottom: "0!important",
      paddingTop: "0!important",
    },
    menuPaper: () => ({
      background: "linear-gradient(180deg, #032d42 0%, #021e2d 100%)",
      backdropFilter: "blur(20px)",
      borderRadius: "16px",
      boxShadow: "0 20px 60px rgba(0, 0, 0, 0.4), 0 0 1px rgba(160, 196, 109, 0.3)",
      border: "1px solid rgba(160, 196, 109, 0.2)",
      overflow: "hidden",
      minWidth: "200px",
      animation: "slideIn 0.25s cubic-bezier(0.4, 0, 0.2, 1)",
      "@keyframes slideIn": {
        from: { opacity: 0, transform: "translateX(-12px) scale(0.95)" },
        to: { opacity: 1, transform: "translateX(0) scale(1)" },
      },
    }),
    userBadgeItem: (theme) => ({
      backgroundColor: "rgba(255, 255, 255, 0.05)",
      bottom: 0,
      display: "flex",
      justifyContent: "center",
      position: "sticky",
      borderRadius: "14px",
      margin: "8px",
      transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
      border: "1px solid rgba(255, 255, 255, 0.08)",
      "&:hover": {
        backgroundColor: "rgba(160, 196, 109, 0.15)",
        transform: "translateY(-3px)",
        boxShadow: "0 8px 20px rgba(0, 0, 0, 0.2)",
      },
    }),
    dropdownButton: {
      position: "absolute",
      right: "2px",
      top: "50%",
      transform: "translateY(-50%)",
      color: "rgba(255, 255, 255, 0.4)",
      padding: "4px",
      transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
      borderRadius: "6px",
      "& .MuiSvgIcon-root": {
        fontSize: "0.9rem",
      },
      "&:hover": {
        color: "#A0C46D",
        backgroundColor: "rgba(160, 196, 109, 0.2)",
        transform: "translateY(-50%) scale(1.1)",
      },
    },
    recentlyViewedTitle: {
      px: 2.5,
      py: 1.5,
      fontWeight: 700,
      fontSize: "0.65rem",
      textTransform: "uppercase",
      letterSpacing: "0.1em",
      color: "#A0C46D",
      borderBottom: "1px solid rgba(160, 196, 109, 0.25)",
      background: "linear-gradient(180deg, rgba(0, 40, 67, 0.4) 0%, transparent 100%)",
    },
  };
};
